export const MAX_TOTAL_BYTES = 5 * 1024 * 1024;
export const MAX_IMAGES = 10;
export const RECOMMENDED_IMAGES = 4;
export const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
export const MAX_SMS_LENGTH = 160;
